import axios from 'axios'

const service = axios.create({
    // baseURL: process.env.VUE_APP_BASE_API,
    baseURL: '/api/v1/chain-browser-service/',
    timeout: 40000, // request timeout
});
service.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8';

// response interceptor
service.interceptors.response.use(
    (response) => {
      const res = response.data;
      if (res.code !== '0000') {
        return Promise.reject(res);
      }
      return res;
    },
    (error) => {
      console.log(`err${error}`); // for debug
      return Promise.reject(error);
    },
);
  
export default service;
  